@if (loadData) {
  <div id="global-timer" class="global_timer" [ngClass]="{ timer_with_text: textTimer !== '' }">
    @if (textTimer !== '') {
      <span class="global_timer__text">{{ textTimer }}</span>
    }
    <div class="global_timer__countdown">
      @if (counter) {
        <div class="global_timer__block-time">
          <span class="global_timer__digit">{{ counter.days | timerDigit }}</span>
          <span class="global_timer__unit" i18n="@@timer.days">days</span>
        </div>
        <div class="global_timer__block-time">
          <span class="global_timer__digit">{{ counter.hours | timerDigit }}</span>
          <span class="global_timer__unit" i18n="@@timer.hours">hours</span>
        </div>
        <div class="global_timer__block-time">
          <span class="global_timer__digit">{{ counter.minutes | timerDigit }}</span>
          <span class="global_timer__unit" i18n="@@timer.minutes">minutes</span>
        </div>
        <div class="global_timer__block-time">
          <span class="global_timer__digit seconds">{{ counter.seconds | timerDigit }}</span>
          <span class="global_timer__unit" i18n="@@timer.seconds">seconds</span>
        </div>
      }
    </div>
  </div>
}
